import { z } from 'zod'
import type { UiStrings } from '@/constants/ui-locale'

export function createLoginSchema(
  messages: Pick<UiStrings, 'emailRequired' | 'emailInvalid' | 'passwordRequired'>
) {
  return z.object({
    email: z.string().min(1, messages.emailRequired).email(messages.emailInvalid),
    password: z.string().min(1, messages.passwordRequired),
  })
}

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>
